import axios from 'axios'
import injector from 'vue-inject';

axios.defaults.withCredentials = true;

export default class RemoteService {

    constructor() {
        this.name = '';
        this.XAUTH_TOKEN_HEADER_NAME = 'x-auth-token';
        this.token = '';
        axios.interceptors.response.use(config => {
            this.token = config.headers[this.XAUTH_TOKEN_HEADER_NAME] || this.token;
            return config;
        }, function (error) {
            return Promise.reject(error);
        });
        axios.interceptors.request.use(config => {
            if (this.token)
                config.headers[this.XAUTH_TOKEN_HEADER_NAME] = this.token;
            return config;
        }, function (error) {
            return Promise.reject(error);
        });
    }

    login(userName, password) {
        return axios.post(REMOTE_URL + '/authenticate', null, {params: {username: userName, password: password}});
    }

    logout() {
        console.log(REMOTE_URL);
        return axios.post(REMOTE_URL + '/logout');
    }

    openFugaso(name) {
        return axios.post(REMOTE_URL + '/openFugaso', null, {params: {gameName: name}});
    }

    openGameArt(gameId) {
        return axios.post(REMOTE_URL + '/openGameArt', null, {params: {gameId: gameId}});
    }

    openGame(company, name, id, device, closeUrl, mode) {
        return axios.post(REMOTE_URL + '/openGame', null, {
            params: {
                company,
                gameName: name,
                gameId: id,
                device,
                closeUrl,
                mode
            }
        });
    }

    getBalance() {
        return axios.get(REMOTE_URL + '/balance', {params: {'_': Math.random()}})
    }

    cashOut(receiver, amount) {
        return axios.post(REMOTE_URL + '/cashOut', null, {params: {receiver, amount}});
    }

    cards() {
        return axios.get(REMOTE_URL + '/cards', {params: {'_': Math.random()}});
    }

    transfer(sender, amount) {
        return axios.post(REMOTE_URL + '/transfer', null, {params: {sender, amount}});
    }

    checkout(amount) {
        return axios.post(REMOTE_URL + '/checkout', null, {params: {amount}});
    }

    status(checkOutId) {
        return axios.get(REMOTE_URL + '/status', {});
    }

    ask() {
        return axios.get(REMOTE_URL + '/ask', {});
    }
}

injector.service('service', RemoteService)